__turbopack_context__.v({
  "breadcrumbs": "breadcrumbs-module-scss-module__H0OA5a__breadcrumbs",
  "current": "breadcrumbs-module-scss-module__H0OA5a__current",
  "item": "breadcrumbs-module-scss-module__H0OA5a__item",
  "link": "breadcrumbs-module-scss-module__H0OA5a__link",
  "skeleton": "breadcrumbs-module-scss-module__H0OA5a__skeleton",
});
